































































































































































import { Vue, Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class OrgAboutPage extends Vue {
  dialog= false;

  dialog1= false;

  get orgAbout() {
    return this.$store.state.orgObj;
  }
}
